import Vue from 'vue';
import Router from 'vue-router';
import { Cookie } from '@/utils';

import routes from './routes';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    transitionOnLoad: true,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    root: '/',
    routes,
});

router.beforeEach((to, from, next) =>
{
    const hasAccessToken = Cookie.get(process.env.ACCESS_TOKEN) !== null;

    const needAuthentication = to.meta.auth;

    if(needAuthentication && !hasAccessToken) return next('/signin');

	if(!needAuthentication && hasAccessToken) return next('/');

    return next();
});



// WEBPACK FOOTER //
// ./src/router/index.js